import { render, staticRenderFns } from "./DepositPolicy.vue?vue&type=template&id=276ebe0b&scoped=true"
import script from "./DepositPolicy.vue?vue&type=script&lang=js"
export * from "./DepositPolicy.vue?vue&type=script&lang=js"
import style0 from "./DepositPolicy.vue?vue&type=style&index=0&id=276ebe0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276ebe0b",
  null
  
)

export default component.exports